<template>
  <Shop :id="$route.params.id" ref="shop" />
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Shop from '@kvass/shop'
export default {
  props: {
    id: String,
    accessToken: String,
  },
  watch: {
    id: {
      handler: 'fetch',
      immediate: true,
    },
  },
  computed: {
    ...mapState('Shop', ['item', 'promises', 'states']),
  },
  methods: {
    ...mapActions('Shop', {
      fetch(dispatch) {
        return dispatch('fetch', [{ id: this.id }, { query: 'ShopView' }]).then(() => {
          if (!this.item.id) return this.$router.replace({ name: 'notfound' })
        })
      },
    }),
  },
  metaInfo() {
    return {
      title: this.states.fetchOne
        ? this.$t('loading', { resource: this.$tc('addonShop').toLowerCase() + '...' })
        : `${this.$tc('shopShort')} | ${[this.$path('item.reference.name'), this.$path('item.project.name')]
            .filter(Boolean)
            .join(' - ')}`,
    }
  },
  components: {
    Shop,
  },
}
</script>

<style lang="scss"></style>
